/* Workshop Mono motion.
   Reveal only. Parallax and ghost-drift are pure CSS scroll-driven animations
   (animation-timeline: view()), so this file adds no scroll listener. Browsers
   without scroll-timeline get the static composition, which is a complete
   design on its own.

   Run-once guard: slc-head.liquid is rendered from layout/theme.liquid AND from
   the homepage sections, so this script tag can appear twice on one page. */
(function () {
  if (window.__slcWorkshopInit) return;
  window.__slcWorkshopInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function run() {
    var items = document.querySelectorAll('.slc-rv:not(.is-in)');
    if (!items.length) return;

    if (reduce.matches || !('IntersectionObserver' in window)) {
      for (var i = 0; i < items.length; i++) items[i].classList.add('is-in');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    items.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Theme editor re-renders sections without a page load. */
  document.addEventListener('shopify:section:load', run);
})();
